import React from 'react';
import { withRouter, BrowserRouter as Router, useLocation } from  'react-router-dom';
import PropTypes from 'prop-types';

import { compose, withHandlers, lifecycle, withState } from 'recompose';

import { connect } from 'react-redux';

import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import Routes from '../Components/Routes';
import Footer from '../Components/Footer';
import Header from '../Components/Header';

import { theme, commonStyles, COLORS } from '../styles/styles';
import logoLong from '../assets/icon_new.svg';
  //import logoLong from '../assets/futureshiftLong.png';
//import logoLong from '../assets/futureShiftSmall.png';
import 'typeface-roboto';
import BreadCrumbArea from '../Components/BreadCrumbArea';
import { messageList } from '../redux/selectors';
import MessageList from '../Components/MessageList';
import ChangeProfilePopup from '../Components/Popups/ChangeProfilePopup';
import { selectUserPrograms, selectUserModule, toggleSplashView, selectAssessment, selectRollout, setApproved, setCost, selectUserContent, setReference } from '../redux/reducers/userProgramsFull';
import { authUserRequest, getTokenFromCookies, logoutUserRequest, authAdminRequest } from '../redux/reducers/login';
import AddCodePopup from '../Components/Popups/AddCodePopup';
import SaveEditPopup from '../Components/Popups/SaveEditPopup';
import Notification from '../Components/Popups/Notification';

import { MDBIcon, MDBSpinner} from "mdbreact";
import InviteDeclineReasonPopup from '../Components/Popups/InviteDeclineReasonPopup';
import ThinkToolPopup from '../Components/Popups/ThinkToolPopup';

import { withCookies, Cookies } from 'react-cookie';

import PropagateLoader from 'react-spinners/PropagateLoader'
import {read_cookie} from 'sfcookies'
import LoadingScreen from 'react-loading-screen';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import SystemPopup from '../Components/Popups/SystemPopup';

import Announcements from '../Components/Popups/Announcements';
import LogbookPopup from '../Components/Popups/LogbookPopup';
import CookieConsent from "react-cookie-consent";
import ModalPopup from '../Components/Popups/ModalPopup';
import { FOOTER_TEXTS } from '../constants';

import UpdatePopup from '../Components/Popups/UpdatePopup';
import ZoomPopup from '../Components/Popups/ZoomPopup';

import { checkDownloadRequest, checkUploadRequest } from '../redux/reducers/checkInternet';
import ModalRegistrationPopup from '../Components/Popups/ModalRegistrationPopup';
import ResubmissionPopup from '../Components/Popups/ResubmissionPopup';
import { assignmentRequestRequest, setMediaType, setRequestType } from '../redux/reducers/assignmentRequest';
import ExtensionPopup from '../Components/Popups/ExtensionPopup';
import PagePopup from '../Components/Popups/PagePopup';
import { popiRequest, showEula, showPopi } from '../redux/reducers/popi';
import { turnitinEulaRequest, turnitinRequest } from '../redux/reducers/turnitin';
import { requestForToken } from '../Components/firebase';
import NotificationFire from '../firebaseNotifications/Notification'
import TurnitinModal from '../Components/TurnitinModal';
import SubmitExamModal from '../Components/SubmitExamModal';
import SaveModal from '../Components/SaveModal';
import ReturnModal from '../Components/ReturnModal';
import { setReturnItem, showReturnModal } from '../redux/reducers/view';
import authHOC from '../Components/AuthHOC';
import ExampleModal from '../Components/ExampleModal';
import DiabilityModal from '../Components/DiabilityModal';
import { xapiRequest } from '../redux/reducers/xapi';
const cookies = new Cookies();




const App = ({ classes,showSystem,handleAgreeEula,handleAgree, internet,parsedHash, showProfile, selectUserPrograms,selectUserModule, loginReducer, programs, view, programsFull,handlePolicyPopup, showPolicy,popups, handleTerms, showTerms,...props }) => (
 
  <MuiThemeProvider theme={theme}>
    
    <div className="mainBg-grey"></div>
    <div className="noView">
      <div className="z-depth-3  noView-container" >
        <div style={{height:25, textAlign: 'center'}} className="secondary-color w-100">
        <MDBIcon style={{color: '#ffffff',paddingTop: 7,fontSize: 13,paddingRight: 10,paddingLeft: 10}} icon="exclamation" />
        </div>
        <div style={{padding: 10, fontSize: 13}}>
          This is better viewed in portrait.
        </div>
      </div>
      <div className="noView-bg"></div>
    </div>
    <div className="app-background">
      <div className={classes.root}>
      

    {loginReducer.user  && <Header /> }
    {loginReducer.user  && <BreadCrumbArea /> }
   {/*loginReducer.user && window.zE("messenger", "loginUser", function (callback) {
  console.log('new-jwt-for-user', loginReducer.user)
  callback(loginReducer.user.zendesk_token)
})*/} 

   
        <Routes />
       
        <MessageList/>
        <ChangeProfilePopup/>
        <AddCodePopup />
        <ResubmissionPopup />
        <ExtensionPopup />
        <Notification />

        <ModalRegistrationPopup/>
        <SaveModal/>
        <ReturnModal/>
        
     
        <Announcements/>
        {/* <ModalRegistrationForm/> */}
        
        
        {view.declineInviteReasonPopup && <InviteDeclineReasonPopup />}
        {!showSystem && <SystemPopup/>}
        {popups.length>0 && (
          <div>
            {console.log('POPUp KILL', popups)}
             {popups.map((item, index) => (
              
       <ZoomPopup
       pathToIframeFile={item.path}
       selectedContent={item}
       zDepth = {index}
     />
    ))}
          </div>
        )}
        <div id="popup-container" style={{width:'100%', height:'calc(100% - 87px)', top:61,left:0, right:0, bottom:0, position:'fixed', zIndex:"99999", pointerEvents:'none'}}/>
        <div id="popup-container2" style={{width:'100%', height:'calc(100% - 87px)', top:61,left:0, right:0, bottom:0, position:'fixed', zIndex:"99999",  pointerEvents:'none'}}/>
        
        <ThinkToolPopup popup={view.thinkToolPopup}/>
        <SaveEditPopup/>
      </div>

      <div><Footer handleTerms={handleTerms}/></div>
      <TurnitinModal/>
      <SubmitExamModal/>
      <DiabilityModal/>
    </div>

    {showPolicy && <ModalPopup type='success' color='success' title='Cookie Policy' body={FOOTER_TEXTS.cookie} handleClose={handlePolicyPopup()} showClose={true}/>}
   

     {(programsFull.showSplashView && loginReducer.isLoggedIn) && <div style={{backgroundColor:COLORS.grey, width:"100%", height:"100%", position:'absolute', top:0, left:0, zIndex:12000, textAlign: 'center'}}>
     <div style={{textAlign:'center', width:'100%'}}>
      <div style={{ width:400, margin:'0 auto', padding:22}}>
      <h5  style={{color:'#FFFFFF',fontFamily:'PTSans-Regular', width:"100%", textAlign:'center',fontSize:16, marginTop:80}}>Please hang on... we are busy logging you in.</h5>
      <h5  style={{color:'#FFFFFF',fontFamily:'PTSans-Regular', width:"100%", textAlign:'center',fontSize:25, marginTop:30}}>If this is taking too long, please check your internet connectivity and clear your browser cache before refreshing.</h5>
      
      </div>
      </div>
      
      <div style={{position: 'absolute',top: '50%',left: '50%',transform: 'translate(-50%,-50%)',width: 200,height: 200,}}>
      <img src={logoLong} style={{height:100, marginBottom:10}}/>
      <div style={{textAlign:'center', position:'absolute', left:"50%", marginTop:15}}>
        
      <PropagateLoader
         
         sizeUnit={"px"}
         size={15}
         color={'#FFFFFF'}
         loading={true}
       />
      </div>
 
     
       <div style={{width:300}}>
        {navigator.connection && <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:45}}>Network Type: {navigator.connection.effectiveType}</h5>}
        {navigator.connection && <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:10}}>Estimated Download Speed: {navigator.connection.downlink} MB/s</h5>}
        {navigator.connection && <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:10}}>Ping: {navigator.connection.rtt} ms</h5>}
        <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:10}}>Actual Download Speed: {internet.downloadSpeed} mb/s</h5>
    
       </div>
        
      </div>
       
    </div>}
  
   
    
    {props.version.PWAcurrent!=props.version.PWANew && 
    <UpdatePopup/>
    
    }
      {props.popiReducer.showPopi && <PagePopup handlePopupToggle={handleAgree} markup={FOOTER_TEXTS.popi} title={'POPI'} />}
      {props.popiReducer.showEula && <PagePopup handlePopupToggle={handleAgreeEula} markup={props.popiReducer.eula} title={'TURN IT IN EULA'} />}
  
    {showTerms && <ModalPopup type='success' showModal={true} color='success' title='Terms &amp; Conditions' body={FOOTER_TEXTS.privacy} handleClose={handleTerms} closeModal = {() => handleTerms()} showClose={true}/>}
    <CookieConsent
    location="bottom"
    buttonText="I Accept"
    cookieName="cpsCookie"
    style={{ background: "#2B373B" }}
    buttonStyle={{ backgroundColor: "#13a2d9",color: "#FFFFFF", fontSize: "13px" }}
    expires={150}
    enableDeclineButton
    onDecline={() => {handlePolicyPopup()}}
    
    declineButtonText="Cookie Policy"
    setDeclineCookie={false}
    declineButtonStyle={{ color: "#FFFFFF", fontSize: "13px" }}>
    This website uses cookies to enhance the user experience. By using CPS Learn you accept our use of cookies.
</CookieConsent>
<NotificationFire/>
{/* <ExampleModal/> */}
   
  </MuiThemeProvider>
  
);

App.propTypes = {
  classes: PropTypes.instanceOf(Object),
};

const styles = () => ({
  ...commonStyles,
  root: {
    height:"100%",
    flexGrow: 1
  }
});

const mapStateToProps = state => ({
  teamMembersFull: state.teamMembersFullReducer,
  showProfile: state.userProgramsFullReducer.showProfile,
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  programs: state.userProgramsFullReducer.programs,
  programsFull:state.userProgramsFullReducer,
  version:state.PWAReducer,
  popups: state.viewReducer.popups,
  internet:state.checkInternetReducer,
  popiReducer:state.popiReducer
  
});

const mapDispatchToProps = dispatch => ({
  toggleSplashView: bool => dispatch(toggleSplashView(bool)),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  selectRollout: rolloutId => dispatch(selectRollout(rolloutId)),
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  setRequestType: type => dispatch(setRequestType(type)),
  setApproved: int => dispatch(setApproved(int)),
  logoutUserRequest: token => dispatch(logoutUserRequest(token)),
  turnitinEulaRequest: () => dispatch(turnitinEulaRequest()),
  checkDownload: () => dispatch(checkDownloadRequest()),
  checkUpload: () => dispatch(checkUploadRequest()),
  setCost: type => dispatch(setCost(type)),
  setMediaType: string => dispatch(setMediaType(string)),
  assignmentRequestRequest: (type) => dispatch(assignmentRequestRequest(type)),
  popiRequest: () => dispatch(popiRequest()),
  showPopi: bool => dispatch(showPopi(bool)),
  showEula: bool => dispatch(showEula(bool)),
  setReference:string => dispatch(setReference(string)),
  turnitinRequest:()=>dispatch(turnitinRequest()),
  showReturnModal:string => dispatch(showReturnModal(string)),
  setReturnItem:string => dispatch(setReturnItem(string)),
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  xapiRequest: (string) => dispatch(xapiRequest(string)),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
});


export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withState('showPolicy', 'togglePolicy', false),
  withState('showTerms', 'toggleTerms', false),
  withState('showSystem', 'toggleSystem', false),
  withHandlers({
    handleTabValueChange: props => (event, value) => {props.handleChangeTabValue(value)},
    handlePolicyPopup: props => () => {
      props.togglePolicy(!props.showPolicy)
    },
    handleTerms: props => () => {
      props.toggleTerms(!props.showTerms)
    },
    handleAgree: props => () => {
      props.popiRequest()
      props.showPopi(false)
    },
    handleAgreeEula: props => () => {
      props.turnitinEulaRequest()
      props.showEula(false)
    },
    useQuery:props => () => {
      const search = props.location.search; // could be '?foo=bar'
      const params = new URLSearchParams(search);
      const foo = params.get('systemDown'); // bar
      
      if( props.location.search=='?system=true'){

        props.toggleSystem(true)
      }
     
      
    }
  }),
  lifecycle({
    componentDidMount(){
      this.props.toggleSplashView(true);
      this.props.checkDownload();
      this.props.useQuery();
      if(cookies.get('returnItem') ){
       this.props.setReturnItem(JSON.parse(read_cookie('returnItem')))
      }
      //this.props.turnitinRequest();
    },
    componentWillReceiveProps(nextProps){
      if(this.props.popiReducer.showPopi==false && nextProps.popiReducer.showPopi==true){
        this.props.xapiRequest({xapiType:'Registered'})
      }
      if(!this.props.loginReducer.user && nextProps.loginReducer.user){
        this.props.xapiRequest({xapiType:'Logged In'})
      }
      console.log('return now2',this.props.view.returnItem, nextProps.view.returnItem)
       if(this.props.view.returnItem != nextProps.view.returnItem && nextProps.loginReducer.user && this.props.view.returnItem.type!='Assignments'){
          this.props.showReturnModal(true)
        }
      //console.log('cookies return 3', this.props.view.returnItem)
      if( (this.props.programsFull.isFetched==false && nextProps.programsFull.isFetched==true )){
        this.props.toggleSplashView(false);
        const search = nextProps.location.search; // could be '?foo=bar'
        const params = new URLSearchParams(search);
        if(params.get("accepted")=="true"){
          
          nextProps.selectUserPrograms(parseInt(params.get("program_id")))
          nextProps.selectUserModule(parseInt(params.get("module_id")))
          nextProps.selectAssessment(parseInt(params.get("survey_id")))
          nextProps.selectRollout(parseInt(params.get('rollout_id')))
          nextProps.setRequestType(params.get('type'))
          nextProps.setCost(params.get('cost'))
          nextProps.selectUserContent(parseInt(params.get('content_id')))
          nextProps.setApproved(1)
          nextProps.setReference(params.get('reference'))
          nextProps.assignmentRequestRequest(params.get('type'))
          nextProps.setMediaType('pop')
        }
      }else{
        
      }
      if(nextProps.loginReducer.user && nextProps.loginReducer.user.popiApproved==0 && !this.props.loginReducer.user){
        this.props.showPopi(true)
      }
      if(nextProps.loginReducer.user && !this.props.loginReducer.user){
        console.log('read_cookie',nextProps.loginReducer.user)
        if(read_cookie('returnItem').length!=0 ){
          this.props.setReturnItem(JSON.parse(read_cookie('returnItem')))
         }
      }
      // if(this.props.internet.downloadSpeed!=nextProps.internet.downloadSpeed){
      //   this.props.checkUpload();
      // }
  
    }
  }),
  withCookies,
  authHOC,
  withStyles(styles),
)(App);
